"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorFunctionFactoryTermStrLangdir = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const TermFunctionStrLangdir_1 = require("./TermFunctionStrLangdir");
/**
 * A comunica TermFunctionStrLang Function Factory Actor.
 */
class ActorFunctionFactoryTermStrLangdir extends bus_function_factory_1.ActorFunctionFactoryDedicated {
    constructor(args) {
        super({
            ...args,
            functionNames: [utils_expression_evaluator_1.SparqlOperator.STRLANGDIR],
            termFunction: true,
        });
    }
    async run(_) {
        return new TermFunctionStrLangdir_1.TermFunctionStrLangdir();
    }
}
exports.ActorFunctionFactoryTermStrLangdir = ActorFunctionFactoryTermStrLangdir;
//# sourceMappingURL=ActorFunctionFactoryTermStrLangdir.js.map